import { render, staticRenderFns } from "./StatsList.vue?vue&type=template&id=2e3d42ef&scoped=true&"
import script from "./StatsList.vue?vue&type=script&lang=js&"
export * from "./StatsList.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style2 from "./StatsList.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3d42ef",
  null
  
)

export default component.exports